import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ClipboardDocumentIcon, CheckIcon, ExclamationCircleIcon } from '@heroicons/react/20/solid';

import { Card, Cluster, Button } from '@nearst/ui';

import styles from './ChannelIssues.module.scss';

const FeedUrl = ({ url, channelDefinition }) => {
	const [status, setStatus] = useState('idle');
	const timerRef = useRef(null);

	useEffect(() => {
		return () => clearTimeout(timerRef.current);
	}, []);

	const handleCopy = useCallback(async () => {
		try {
			await navigator.clipboard.writeText(url);
			setStatus('copied');
		} catch {
			setStatus('error');
		}
		clearTimeout(timerRef.current);
		timerRef.current = setTimeout(() => setStatus('idle'), 2000);
	}, [url]);

	const icon =
		status === 'copied' ? (
			<CheckIcon height={16} />
		) : status === 'error' ? (
			<ExclamationCircleIcon height={16} />
		) : (
			<ClipboardDocumentIcon height={16} />
		);

	const label = status === 'copied' ? 'Copied' : status === 'error' ? 'Failed' : 'Copy';

	return (
		<Card title="Feed URL" description={`Use this URL to connect your ${channelDefinition.title} catalogue.`}>
			<Cluster>
				<code className={styles.feedUrl}>{url}</code>
				<Button onClick={handleCopy}>
					{label} {icon}
				</Button>
			</Cluster>
		</Card>
	);
};

export default FeedUrl;
